import React, {PureComponent} from "react"
import CurrencyInput from "react-currency-input"

export default class InputDinheiroBR extends PureComponent {
    id

    constructor(props) {
        super(props)
        var value = ""
        if (props.defaultValue != undefined) {
            value = props.defaultValue
        }
        if (props.value != undefined) {
            value = props.value
        }
        this.state = {
            value: value,
            error: false
        }


    }

    onChange = (ele, a) => {

        var valor = this.removerFormatacao(ele)
        if (valor == 0) {
            valor = ""
        }

        this.props.onChange(ele, valor)
        this.setState({value: ele})
    }

    render() {

        return (<div className={this.props.sizeClass}>
            <div className="form-group label-floating">
                <label className="control-label">{this.props.label}</label>
                <CurrencyInput decimalSeparator={","} thousandSeparator={"."} precision={3}
                               prefix={"R$"}
                               value={this.state.value}
                               onChange={this.onChange}
                               className="form-control"/>
            </div>
            {
                this.props.error ?
                    <span className="label label-danger">{this.props.error}</span> : null
            }

        </div>)

    }

    removerFormatacao(texto) {
        if (texto.trim() == "") {
            return ""
        }
        texto = texto.replace("R$", "")
        texto = texto.split(".").join("")
        texto = texto.split(",").join(".")
        return parseFloat(texto)
    }

    formatar(number) {
        return number.toLocaleString("pt-BR", {style: "currency", currency: "BRL", minimumFractionDigits: 3})
    }
}



// WEBPACK FOOTER //
// ./src/components/InputDinheiroBR.js